module.exports = {"title":"Я был уверен, что этот парень сидел","description":"Владимиру ВЫСОЦКОМУ 80 ЛЕТ: спецпроект «Ленты.ру»","image":"http://vysotsky.lenta.ru/img/share.png","url":"http://vysotsky.lenta.ru/","fbappid":323861208109451,"GTM":"GTM-T6TCRTW","top100":0,"clientTop100":0,"yaMetrika":27714477}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 5
// module chunks = 0